import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
	IGetPublicTripResponse,
	BackendService, BaseDataService,
	IGetPublicTripRequest,
} from 'nr-common';
import { WebsiteService } from '../../services/website.service';
import { CommonService } from '../../services/common.service';

@Component({
	selector: 'nr-mytrip',
	templateUrl: './mytrip.component.html',
	styleUrls: ['./mytrip.component.scss'],
	standalone: false,
})
export class MyTripComponent implements OnInit {
	public readonly trip$ = signal<IGetPublicTripResponse | null>(null);
	public readonly loading$ = signal(false);
	public readonly error$ = signal(false);

	constructor(
		private backend: BackendService,
		private baseData: BaseDataService,
		private commonService: CommonService,
		private route: ActivatedRoute,
		private website: WebsiteService,
		private translate: TranslateService,
	) {
		this.commonService.showNavbar = false;
		this.commonService.showFooter = false;
	}

	get locale(): string {
		return this.baseData.getLangCodeFromLingua(this.baseData.getLingua());
	}

	get isDocumentsVisible(): boolean {
		return !!this.trip$()?.header?.isDocumentPublishing;
	}

	async ngOnInit() {
		try {
			this.loading$.set(true);
			const tripId = +this.route.snapshot.paramMap.get('tripId');
			const secretKey = this.route.snapshot.queryParamMap.get('s') || 'null';
			const request: IGetPublicTripRequest = {
				offertaID: tripId,
				key: secretKey,
				siteID: this.website.currentWebsite.id,
				lingua: this.baseData.getLingua(),
			};
			const trip = await this.backend.post('b2c/public/trip', request) as IGetPublicTripResponse;
			this.trip$.set(trip);

			// Switch the UI language to the trip's own language
			if (trip.language) {
				this.translate.use(this.baseData.getLangCodeFromLingua(trip.language));
			}
		} catch {
			this.error$.set(true);
		} finally {
			this.loading$.set(false);
		}
	}
}
